module.exports = __webpack_public_path__ + "img/27.ca381cde.jpg";